import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { PROCESS, HOME, FORM } from '../content/site';
import { PageHeader } from '../components/blocks/PageHeader';
import { ProcessSteps } from '../components/blocks/ProcessSteps';
import { Section, Reveal, ButtonLink } from '../components/ui/Primitives';
export function ProcessPage() {
  const {
    language
  } = useLanguage();
  const t = PROCESS[language];
  const home = HOME[language];
  const form = FORM[language];
  return <>
      <PageHeader eyebrow={t.eyebrow} title={home.processTeaser.headline} sub={form.subtitle} data-id="element-353" data-mp="1y0ebdpxgjdxu" />

      <Section tone="cream" data-id="element-354" data-mp="1t2mjux0q5tu6">
        <ProcessSteps data-id="element-355" data-mp="1szql56h1z14o" />
      </Section>

      <Section tone="espresso" data-id="element-356" data-mp="1p0rjbuqmbkhg">
        <Reveal data-id="element-357" data-mp="1p1j224z49nqb">
          <div className="mx-auto max-w-2xl text-center" data-id="element-358" data-mp="1p22ljq4f0k6g">
            <h2 className="font-serif text-3xl font-light leading-tight tracking-tight text-pearl sm:text-4xl" data-id="element-359" data-mp="1k1enwllol539">
              {home.contactTeaser.headline}
            </h2>
            <p className="mt-5 text-base font-light leading-relaxed text-pearl/65" data-id="element-360" data-mp="296oviwenzwdl">
              {home.contactTeaser.sub}
            </p>
            <div className="mt-10 flex justify-center" data-id="element-361" data-mp="2dyf9rdgq34aa">
              <ButtonLink to="/contact" variant="light" data-id="element-362" data-mp="205z8ah3gzebh">
                {home.contactTeaser.cta}
              </ButtonLink>
            </div>
          </div>
        </Reveal>
      </Section>
    </>;
}